import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import ShopCategory from './Pages/ShopCategory'; 
import Product from './Pages/Product';
//import Custom from './Pages/Custom';
import Cart from './Pages/Cart'
import LoginSignup from './Pages/LoginSignup'
import Footer from './Components/Footer/Footer';
import Confirmation from './Pages/Confirmation';
import AllProducts from './Pages/AllProducts';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';


function App() {
  return (
    <div>
      <BrowserRouter>
      <ScrollToTop/>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path='/clothes' element={<ShopCategory category="clothes"/>}/>
        <Route path='/ready-to-ship' element={<ShopCategory category="ready to ship"/>}/>
        <Route path='/patterns' element={<ShopCategory category="patterns"/>}/>
        <Route path='/accessories' element={<ShopCategory category="accessories"/>}/>
        <Route path='/allproducts' element={<AllProducts/>}/>
        <Route path='/product' element={<Product/>}>
          <Route path=':productId' element={<Product/>}/>
        </Route>
        <Route path='/cart' element={<Cart/>}/>
        <Route path='/login' element={<LoginSignup/>}/>
      </Routes>
      <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
